export const REDIRECTING_EVENTS = Object.freeze({
  PAGE_VIEWED: 'mao_dupla__transition_page_view_via_visit_schedule_button',
});

export const CRM_CONTEXT = 'CRM_CONTEXT';
